module.exports = __webpack_public_path__ + "static/media/crest.cad0dcdc.png";